import { useState } from 'react';
import { ComponentRendering } from '@sitecore-jss/sitecore-jss-nextjs';

import { SearchMenuFields } from '../../../types';
import { useComponentProps } from '../../../utils/hooks/useComponentFields';
import { SearchMenuInput } from './SearchMenuInput';

export const MobileSearchMenu = () => {
  const componentProps: ComponentRendering | null = useComponentProps('Search');
  const menuItem = componentProps?.fields as unknown as SearchMenuFields;

  const inputPlaceholderText = menuItem?.searchTextPlaceholder?.value || '';

  const [searchQuery, setSearchQuery] = useState('');

  return (
    <div className="flex w-full bg-gray-50 px-5 pb-10 pt-3">
      <SearchMenuInput
        showSearchButton={true}
        inputPlaceholderText={inputPlaceholderText}
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
        autofocus={false}
      />
    </div>
  );
};
